/**
 * transform to show a default value when the source is empty
 * @param {any} d - source value
 * @param {object} params
 * @param {any} params.value - value to display when empty (default: '-')
 * @param {Array} params.emptyValues - additional values to treat as empty (default: [])
 * @returns {any}
 */
const defaultValueTransform = (d, params = {}) => {
  const { value = '-', emptyValues = [] } = params;

  if (d === null || d === undefined || d === '') {
    return value;
  }

  if (Array.isArray(emptyValues) && emptyValues.includes(d)) {
    return value;
  }

  return d;
};

export default defaultValueTransform;
